import parseQueryString from 'utils/parseQueryString';
import { navigateInternally } from 'utils/bolt';
import { apiPrime } from 'utils/bolt/apiPrime';
import Store from 'store/store';

export const checkEarlyAccess = () => {
	// early access ends July 19th, 16:00 UTC
	const earlyAccessOver = Date.now() > Date.UTC(2023, 6, 19, 16);
	if (earlyAccessOver) {
		return;
	}
	const query = parseQueryString();

	if (query?.['everyday-access'] || query?.['student-access'] || query?.['loyalty-access']) {
		Store.emit('EARLY_ACCESS_WINDOW');
		return;
	}

	// Add loyalty-access on Tuesday July 18 at 9a PT
	const startEarlyAccess2 = Date.now() > Date.UTC(2023, 6, 18, 16);
	if (startEarlyAccess2) {
		if (query?.['loyalty-access']) {
		Store.emit('EARLY_ACCESS_WINDOW');
		return;
		}
	}

	navigateInternally('boltHome');
};

export const checkAccessCode = async (screeningId, accessCode, onAccessCodeSuccess) => {
	Store.emit('SHOW_FULL_LOADER', true);
	const copy = Store.get()?.appData?.copy?.baseCopy || {};

	try {
		const response = await apiPrime({
			method: 'get',
			path: '/check-early-access-code',
			query: {
				screening_id: screeningId,
				early_access_code: accessCode
			}
		});
		if (response.result !== 'ok') {
			Store.emit('SHOW_FULL_LOADER', false);
			return;
		}
		if (response.response?.invalidCode) {
			Store.emit('CHANGE_INFO_SCREEN_MESSAGE', (copy.$EARLY_ACCESS_CODE_INVALID_MESSAGE));
		} else if (response.response?.soldOut) {
			Store.emit('CHANGE_INFO_SCREEN_MESSAGE', (copy.$EARLY_ACCESS_CODE_SOLD_OUT_MESSAGE));
		} else {
			Store.emit('EARLY_ACCESS_CODE_ACCEPTED', (accessCode));
			Store.emit('HIDE_INFO_SCREEN');
			onAccessCodeSuccess();
		}
		Store.emit('SHOW_FULL_LOADER', false);
	} catch (e) {
		Store.emit('SHOW_FULL_LOADER', false);
		console.error('Error checking access code -', e);
		Store.emit('CHANGE_INFO_SCREEN_MESSAGE', (copy.$EARLY_ACCESS_CODE_INVALID_MESSAGE));
		return;
	}
};
